import React, {Component} from 'react';
import {Carousel} from "react-bootstrap";
import config from "../../../config";
import Preloader from "../Preloader/Preloader";

class PictureViewer extends Component {
  handleCloseViewer = () => {
    this.props.onClose();
  };

  render() {
    const {t} = this.props;
    let array, slide, index;
    if (this.props.array && this.props.array.length) {
      array = this.props.array.map(el => {
        return el.image;
      });

      slide = array.map((el, idx) => {
        const imageUrl = config.apiUrl + '/storage/' + el.replace('"', '');
        return (
          el ?
            <Carousel.Item key={idx}>
              {imageUrl ?
                <img
                  className="d-block w-30 picture-viewer__img"
                  src={config.apiUrl + '/storage/' + el.replace('"', '')}
                  alt=""
                />
                : <Preloader/>}
            </Carousel.Item> : []
        )
      });

      index = array.findIndex(el => el === this.props.item);

    }
    return (
      <div className={`picture-viewer ${this.props.picViewer ? 'active' : 'false'}`} onClick={this.handleCloseViewer}>
        <div onClick={e => e.stopPropagation()} style={{margin: 'auto'}}>
          <span className="picture-viewer__close-icon" onClick={this.handleCloseViewer}>{t("picViewer.close")}</span>
          {!this.props.picViewer ?
            null :
            <Carousel className="picture-viewer__carousel"
                      nextIcon={false}
                      prevIcon={false}
                      indicators={false}
                      interval={15000}
                      controls={false}
                      defaultActiveIndex={index}
            >
              {slide}
            </Carousel>
          }
        </div>
      </div>
    )
  }
};

export default PictureViewer;